module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('selectable-grid-row', {
    attrs: {
      "activeRow": _vm.activeRow
    },
    on: {
      "select": _vm.showPromotion
    }
  }, [_c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.item.plu) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("fixedLength")(_vm.item.name, 20)) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("fixedLength")(_vm.typeName, 30)) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.customerGroupName) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [(_vm.showDates) ? _c('span', [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(_vm.promotion.startDate)) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [(_vm.showDates) ? _c('span', [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(_vm.promotion.endDate)) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.promotion.page) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.promotion.positionOnPage) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("formatPrice")(_vm.basePrice)) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("formatPrice")(_vm.item.cost)) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("formatPrice")(_vm._f("rounded")(_vm.discountedPrice))) + "\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm._f("rounded")(_vm.margin)) + "%\n  ")]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.promotion.targetMargin)), (_vm.promotion.targetMargin) ? _c('span', [_vm._v("%")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('selectable-grid-cell', {
    attrs: {
      "row": _vm.row,
      "active-row": _vm.activeRow
    }
  }, [_vm._v("\n    " + _vm._s(_vm.promotion.rewards.rewardMoneyEarnedPerItem || _vm.promotion.rewards.rewardMoneyEarnedPerRedemption || '-') + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-104f1ffe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ViewEvent/SpecialPromotionItem.vue
// module id = 1669
// module chunks = 1